import React from 'react'
import { Context } from './DetailContext'

export const useDetailContext = (): { trikoId: any } => {
    const { trikoId } = React.useContext(Context)
    return { trikoId }
}
